module.exports = {"StatusCode":200,"Payload":[{"tier":"Premium"}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/changeSitePlan.json
// module id = w4SM
// module chunks = 0